<script setup>
  import {MedLink} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "DocumentComponentUrlRedirect",
  });

  defineProps({
    urlRedirect: {
      type: Object,
      required: true,
    },
    overrideTargetUrl: {
      type: String,
      default: null,
    },
  });
</script>

<template>
  <div>
    <MedLink
      :id="urlRedirect.identifier"
      variant="primary"
      target="_blank"
      :href="overrideTargetUrl ?? urlRedirect.target_url"
      :data-test="getTestId('link')"
    >
      {{ urlRedirect.link_text ?? urlRedirect.target_url }}
    </MedLink>

    <template v-if="urlRedirect.file_type && urlRedirect.file_type !== ''">, {{ urlRedirect.file_type }}</template>

    <template v-if="urlRedirect.status && urlRedirect.status !== ''">, {{ urlRedirect.status }}</template>

    <div
      v-if="urlRedirect.description && urlRedirect.description !== ''"
      class="max-w-3xl"
      :data-test="getTestId('url-redirect-description')"
    >
      {{ urlRedirect.description }}
    </div>
  </div>
</template>
